import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { BannersType, heroImageStyles, setWrapperPadding } from 'src/domains/layouts/webview/components/heroEvents/HomepageHeroWidget.style';
import { SerializedStyles } from '@emotion/react';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

export const Wrapper = withConfig(theme => styled('div', { label: 'Wrapper' })<BannersType & { variant: DefaultComponentVariantType | null}>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ bgColor }) => bgColor ? bgColor : theme.star.heroWidget.bgColorSecondary};
    ${({ variant }): SerializedStyles => setWrapperPadding(variant, theme) };
    ${({ banners }): SerializedStyles => heroImageStyles(banners, theme) };
`);
